import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import { Row, Col } from 'reactstrap';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

export const INCENTIVES_SECTIONS = {
  restrictions: 'Requirements and Restrictions:',
  bonus: 'Bonus',
  start: 'Start',
  end: 'End',
};

/**
 * Renders modal info for incentive.
 * @param {string} restrictions
 * @param {number} [startDate]
 * @param {number} [endDate]
 * @param {number} [rebateAmount]
 * @returns {ReactElement}
 */
export function IncentiveModalInfo({ restrictions, startDate = null, endDate = null, rebateAmount = null }) {
  const startedDate = new Date(startDate);
  const expiredDate = new Date(endDate);
  const { restrictions: restrictionsLabel, bonus, start, end } = INCENTIVES_SECTIONS;

  return (
    <div>
      <dl className="mb-0">
        <dt className="mb-0_5 text-gray-darker">{restrictionsLabel}</dt>
        <dd className="text-gray-darker">
          <ContentFragment>{restrictions}</ContentFragment>
        </dd>
      </dl>
      {rebateAmount || startDate || endDate ? (
        <Row>
          {rebateAmount ? (
            <Col className="d-flex flex-column">
              <strong>{bonus}</strong>
              <span>{formatPriceString(rebateAmount)}</span>
            </Col>
          ) : null}
          {startDate ? (
            <Col className="d-flex flex-column">
              <strong>{start}</strong>
              <span>{dateFormat(startedDate, 'mm/dd/yyyy')}</span>
            </Col>
          ) : null}
          {endDate ? (
            <Col className="d-flex flex-column">
              <strong>{end}</strong>
              <span>{dateFormat(expiredDate, 'mm/dd/yyyy')}</span>
            </Col>
          ) : null}
        </Row>
      ) : null}
    </div>
  );
}

IncentiveModalInfo.propTypes = {
  endDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rebateAmount: PropTypes.number,
  restrictions: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
